import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
// 分类组件批量注册
const namesv2 = [];
const typev2 = {};
const filesv2 = require.context("@/components/mapv2/typev2", true, /\.vue$/);
filesv2.keys().forEach(key => {
  let name = key.split("/").pop().replace(/\.\w+$/, "");
  if (name === "index") return;
  namesv2.push(name);
  typev2[name] = filesv2(key).default || filesv2(key);
});
export default {
  data() {
    return {
      names: namesv2
    };
  },
  components: typev2,
  props: ["modeltype"]
};